import React from 'react';

import {
	Container,
	Retweeted,
	RocketSeatIcon,
	Body,
	Avatar,
	Content,
	Header,
	Dot,
	Description,
	ImageContent,
	Icons,
	Status,
	RetweetIcon,
	LikeIcon,
	CommentIcon,
} from './styles';

const Tweet: React.FC = () => {
	return (
		<Container>
			<Retweeted>
				<RocketSeatIcon />
				Você retweetou
			</Retweeted>

			<Body>
				<Avatar />

				<Content>
					<Header>
						<strong>RocketSeat</strong>
						<span>@rocketseat</span>

						<Dot />

						<time>27 de jun</time>
					</Header>

					<Description>Foguete não tem ré!</Description>

					<ImageContent />

					<Icons>
						<Status>
							<CommentIcon />
							20
						</Status>

						<Status>
							<RetweetIcon />
							18
						</Status>

						<Status>
							<LikeIcon />
							6699
						</Status>
					</Icons>
				</Content>
			</Body>
		</Container>
	);
};

export default Tweet;
